import * as Headless from "@headlessui/react";
import React, { useState, useEffect } from "react"; // Keep React/useState/useEffect if needed for internal logic
import { NavbarItem } from "./navbar";
// Removed: import logo from "img/logo.png" // REMOVED
import { Link } from "react-router-dom"; // Keep Link if used internally, otherwise remove
// Removed: import { UserDropdown } from "components/layout/UserDropdown" // REMOVED
// Removed: import useLocalStorage from 'utils/useLocalStorage' // REMOVED

// Icon components remain
function OpenMenuIcon() {
  return (
    <svg data-slot="icon" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M2 6.75C2 6.33579 2.33579 6 2.75 6H17.25C17.6642 6 18 6.33579 18 6.75C18 7.16421 17.6642 7.5 17.25 7.5H2.75C2.33579 7.5 2 7.16421 2 6.75ZM2 13.25C2 12.8358 2.33579 12.5 2.75 12.5H17.25C17.6642 12.5 18 12.8358 18 13.25C18 13.6642 17.6642 14 17.25 14H2.75C2.33579 14 2 13.6642 2 13.25Z" />
    </svg>
  );
}
function CloseMenuIcon() {
  return (
    <svg data-slot="icon" viewBox="0 0 20 20" aria-hidden="true">
      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
    </svg>
  );
}

function MobileSidebar({ open, close, children }) {
  return (
    <Headless.Dialog open={open} onClose={close} className="lg:hidden">
      <Headless.DialogBackdrop
        transition
        className="fixed inset-0 bg-black/30 transition data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <Headless.DialogPanel
        transition
        className="fixed inset-y-0 w-full max-w-80 p-2 transition duration-300 ease-in-out data-[closed]:-translate-x-full"
      >
        <div className="flex h-full flex-col rounded-lg bg-white shadow-sm ring-1 ring-zinc-950/5 dark:bg-zinc-900 dark:ring-white/10">
          <div className="-mb-3 px-4 pt-3">
            <Headless.CloseButton as={NavbarItem} aria-label="Close navigation">
              <CloseMenuIcon />
            </Headless.CloseButton>
          </div>
          {children}
          {/* Removed the hardcoded UserDropdown section from here */}
        </div>
      </Headless.DialogPanel>
    </Headless.Dialog>
  );
}

export function SidebarLayout({ navbar, sidebar, children }) {
  // Removed unused props like isMini, toggleMini
  const [showSidebar, setShowSidebar] = useState(false);
  // Removed isMini state management from here as it's handled in ISCO's App/Sidebar if needed

  return (
    // Use simpler fixed-width sidebar and offset for main content
    <div className="relative isolate flex min-h-svh w-full bg-white max-lg:flex-col lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950">
      {/* Sidebar on desktop - Simplified width handling */}
      <div className="fixed inset-y-0 left-0 z-20 w-64 max-lg:hidden border-r border-zinc-950/5 dark:border-white/5 bg-white dark:bg-zinc-900">
        {/* Pass closeSidebar if the SidebarContent needs it */}
        {React.cloneElement(sidebar, {
          closeSidebar: () => setShowSidebar(false),
        })}
      </div>

      {/* Sidebar on mobile */}
      <MobileSidebar open={showSidebar} close={() => setShowSidebar(false)}>
        {/* Pass closeSidebar if the SidebarContent needs it */}
        {React.cloneElement(sidebar, {
          closeSidebar: () => setShowSidebar(false),
        })}
      </MobileSidebar>

      {/* Navbar on mobile - Only shows the menu toggle */}
      <header className="sticky top-0 z-10 flex items-center px-4 py-2.5 lg:hidden justify-between bg-white dark:bg-zinc-900 border-b dark:border-white/10">
        <NavbarItem
          onClick={() => setShowSidebar(true)}
          aria-label="Open navigation"
        >
          <OpenMenuIcon />
        </NavbarItem>
        {/* Optionally add a logo or title here for mobile */}
        <span className="font-semibold">ISCO</span> {/* Example Title */}
        <div>{/* Placeholder for potential right-side icons */}</div>
      </header>

      {/* Main Content Area - Apply left padding based on desktop sidebar width */}
      <main className="flex flex-1 flex-col lg:pl-64">
        {" "}
        {/* Use fixed padding */}
        {/* Render children directly, header/breadcrumbs are now part of the page components */}
        <div className="grow p-6 lg:p-10">
          <div className="mx-auto max-w-full">{children}</div>
        </div>
      </main>
    </div>
  );
}
